<template lang="html">
  <div v-if="upListUsers" id="body-list-user" :class="{ 'internal-chat-is-ios': isIos, 'internal-chat-is-android' :  isAndroid}">
    <InternalChatMessage
        :selectedUser="selectedUser"
        :upInternalChat="openInternalChat"
        @backInternalChat="closeInternalChat()"
        @closeListChat="closeListChat"
    />

    <div class="header-list bg-primary">
      <div slot="title" class="header-list-sub">
        <div>
          <vs-navbar-title>
            <p class="text-white text-center ml-1 py-3" style="margin-right: 11rem">Chat Interno</p>
          </vs-navbar-title>
        </div>
        <feather-icon
            class="text-white cursor-pointer mr-2"
            icon="ChevronDownIcon"
            @click.stop="closeListChat">
        </feather-icon>
      </div>
    </div>

    <div class="list-user" :class="{ 'list-user-internal-chat-ios': isIos, 'list-user-internal-chat-android': isAndroid}">
      <div slot="header" class="base-sidebar">
        <div class="list-title">
          <p class="list-title-message">Listagem de usuários</p>
        </div>
      </div>

      <div class="search-list-users mb-3">
        <vs-input v-model="searchUser" class="w-full input-rounded-full" icon="search" placeholder="Pesquisar usuário" type="text"/>
      </div>

      <div class="list-main mb-3">
        <VuePerfectScrollbar
            :key="$vs.rtl"
            ref="listScroll"
            :settings="settings"
            class="list-users-scroll-area"
            @ps-y-reach-end="scrollHandler"
        >
          <div
              v-for="(user, index) in users"
              :key="index"
              class="select-user px-4 vx-row cursor-pointer"
              :class="{'bg-warning-gradient text-white': user.unseenMsg}"
              @click.stop="toggleUserName(user)"
          >
            <div class="flex items-center justify-center">
              <div>
                <vs-avatar class="avatar_user icon-navbar mr-2  border-2 border-solid border-white" :badge="user.unseenMsg" v-if="user.image" :src="user.image"/>
                <vs-avatar class="avatar_user icon-navbar mr-2  border-2 border-solid border-white" :badge="user.unseenMsg" v-else/>
              </div>
              <div class="flex-grow">
                <div class="flex flex-col ml-3">
                  <div class="flex items-center mb-1">
                    <h5
                        class="name_user font-semibold ml-1 mt-2"
                        :class="{'text-white name_user font-semibold ml-1 mt-2 ': user.unseenMsg}"
                    >
                      {{ user.username }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import InternalChatMessage from "./InternalChatMessage.vue";
import moduleUser from '@/store/user/moduleUser';

export default {
  name: "InternalChatContact",
  data() {
    return {
      currentPage: 1,
      limitPerPage: 10,
      searchUser: "",
      lastPage: false,
      searchingForUsers: false,
      openInternalChat: false,
      selectedUser: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
    }
  },
  props: {
    upListUsers: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  components: {
    InternalChatMessage,
    VuePerfectScrollbar
  },
  watch: {
    'searchUser'() {
      this.fetch()
    },
    async upListUsers(val) {
      if (val) {
        await this.fetch();
      }
    },
  },
  computed: {
    isIos() {
      return window.innerWidth <= 430 && window.innerHeight <= 932;
    },
    isAndroid() {
      return window.innerWidth <= 393 && window.innerHeight <= 873;
    },
    users(){
      return this.$store.state.user.internalUsers.filter((user) => user.email !== 'root@pedbot.com.br')
    },
    activeUser() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    closeListChat() {
      this.lastPage = false
      this.upListUsers = false
      this.openInternalChat = false
      this.searchingForUsers = false
      this.$emit('downListUsers')
      this.resetActiveChat()
    },
    closeInternalChat() {
      this.lastPage = false
      this.openInternalChat = false
      this.searchingForUsers = false
      this.resetActiveChat()
    },
    toggleUserName(username) {
      this.openInternalChat = true
      this.resetActiveChat(username)
    },
    resetActiveChat(username = null){
      this.selectedUser = username
      this.$store.dispatch('internalChatMessages/setReplyMessage', null);
      this.$store.dispatch('internalChatMessages/resetInternalChatMessage');

      if (username){
        this.$store.dispatch('internalChatMessages/resetUnseenInternalChatMessages', {
          userId: this.activeUser.id,
          userSendingId: username.id
        });
      }
    },
    async fetch() {
      this.currentPage = 1;
      this.searchingForUsers = true

      await this.$store.dispatch("user/fetchPaginated", {
        pagination_page: this.currentPage,
        pagination_limit: this.limitPerPage,
        search_filter: this.searchUser,
        setInInternal: true
      }).then(() => {
        this.$refs.listScroll.$el.scrollTop = 0;
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        this.searchingForUsers = false
      });
    },
    scrollHandler() {
      const scrollTop = this.$refs.listScroll.$el.scrollTop
      const scrollHeight = this.$refs.listScroll.$el.scrollHeight
      const offsetHeight = this.$refs.listScroll.$el.offsetHeight
      const SCROLL_FIXED_VALUE = 150 + (30 * this.currentPage);

      if (
          scrollTop > 0 &&
          this.lastPage === false &&
          this.searchingForUsers === false &&
          scrollTop + SCROLL_FIXED_VALUE >= (scrollHeight - offsetHeight)
      ) {
        this.searchingForUsers = true

        this.$store.dispatch("user/fetchPaginated", {
          concatResults: true,
          setInInternal: true,
          search_filter: this.searchUser,
          pagination_limit: this.limitPerPage,
          pagination_page: this.currentPage + 1,
        }).then((response) => {
          if (response.data.data.paginatedUsers.items.length < this.limitPerPage) {
            this.searchingForUsers = false
            this.lastPage = true
            return;
          }

          this.$nextTick(() => {
            this.$refs.listScroll.$el.scrollTop = this.$refs.listScroll.$el.scrollTop + 120
          })

          this.searchingForUsers = false
          this.currentPage = this.currentPage + 1
        }).catch((error) => {
          console.error(error)
          this.searchingForUsers = false
        })
      }
    },
  },
  created() {},
  async mounted() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule('user', moduleUser)
      moduleUser.isRegistered = true
    }
    await this.fetch();
  },
}
</script>

<style lang="scss">

.list-users-scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 23rem;
}

#body-list-user {
  position: fixed;
  width: 24.9rem;
  left: auto;
  height: 33rem;
  right: 8.57rem;
  bottom: 0;
  z-index: 6000 !important;
}

.header-list {
  margin-right: 0;
  margin-left: 0;
  padding-bottom: 0.2rem;
  width: 24.6rem;
  background: #f0f0f0;
  border: 0 solid #f0f0f0;
  border-radius: 2rem 2rem 0 0;
}

.header-list-sub {
  display: flex;
  align-items: center;
  padding: 0.4rem;
}

.list-user {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.list-title {
  display: inline-flex;
  width: 25rem;
  align-items: center;
  padding-top: 0.5rem;
}

.list-title-message {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  width: 100%;
}

.search-list-users {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 4rem;
  padding-left: 4rem;
  padding-top: 1rem;
}

.list-main {
  display: flex;
  flex-direction: column;
  width: 100%;

  .select-user {
    display: flex;
    justify-content: start;
    height: 3.45rem;
    width: 100%;
    margin-top: 0;
    margin-left: 0;
    border: #E8E8E8 0.1rem solid;

    .name_user {
      font-size: 1rem;
      font-weight: bold;
    }

    .label-message {
      font-size: 1rem;
      margin-left: 0.2rem
    }
  }
}

.internal-chat-is-ios{
  padding-left: 105px;
}

.internal-chat-is-android{
  padding-left: 105px;
}
.list-user-internal-chat-android{
  width: 344px;
}

.list-user-internal-chat-ios{
  width: 345px;
}

</style>